import React from 'react';
import { Users, GraduationCap, Instagram } from 'lucide-react';

export default function TeamSection({ team = [] }) {
  if (!team.length) return null;
  return (
    <section className="bg-white rounded-[10px] border border-[#cbd8dc] p-6" data-testid="team-section">
      <h2 className="text-lg font-semibold text-[#153e44] mb-5 flex items-center gap-2"><Users className="w-5 h-5 text-[#075a6d]" /> Liderança</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {team.map((m, i) => (
          <div key={i} className="flex gap-4" data-testid={`team-member-${i}`}>
            {m.photo && <img src={m.photo} alt={m.name} className="w-20 h-20 md:w-24 md:h-24 rounded-[7px] object-cover shrink-0 border border-[#cbd8dc]" />}
            <div className="min-w-0">
              <h3 className="font-semibold text-[#153e44] leading-snug">{m.name}</h3>
              {m.role && <p className="text-xs text-[#52676e] mt-0.5">{m.role}</p>}
              {m.oab && <p className="text-xs font-semibold text-[#075a6d] mt-1">{m.oab}</p>}
              {m.bio && <p className="text-sm text-[#354c54] leading-relaxed mt-2">{m.bio}</p>}
              {m.education && <p className="text-xs text-[#425a62] mt-2 flex items-start gap-1.5"><GraduationCap className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#075a6d]" /><span>{m.education}</span></p>}
              {m.instagram && (
                <a href={m.instagram} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs font-medium text-[#153e44] hover:text-[#063f4c] mt-2" data-testid={`team-instagram-${i}`}>
                  <Instagram className="w-3.5 h-3.5" /> {m.instagram.replace(/https?:\/\/(www\.)?instagram\.com\//, '@').replace(/\/$/, '')}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
